/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 */

import { loadRuntime } from '@wonderlandengine/api';

/* wle:auto-constants:start */
const Constants = {
    ProjectName: 'Morgan Plus Four',
    RuntimeBaseName: 'WonderlandRuntime',
    WebXRRequiredFeatures: ['local',],
    WebXROptionalFeatures: ['local','hand-tracking','hit-test',],
};
const RuntimeOptions = {
    webgl2: true,
    webgpu: false,
    physx: false,
    loader: false,
    xrFramebufferScaleFactor: 1,
    loadUncompressedImagesAsBitmap: false,
    xrOfferSession: {
        mode: 'auto',
        features: Constants.WebXRRequiredFeatures,
        optionalFeatures: Constants.WebXROptionalFeatures,
    },
    canvas: 'canvas',
};
/* wle:auto-constants:end */

const engine = await loadRuntime(Constants.RuntimeBaseName, RuntimeOptions);
engine.onLoadingScreenEnd.once(() => {
	const el = document.getElementById('version');
	if (el) setTimeout(() => el.remove(), 2000);
});

/* WebXR setup. */

function requestSession(mode) {
	engine
		.requestXRSession(mode, Constants.WebXRRequiredFeatures, Constants.WebXROptionalFeatures)
		.catch((e) => console.error(e));
}

function setupButtonsXR() {
	/* Setup AR / VR buttons */
	const arButton = document.getElementById('ar-button');
	if (arButton) {
		arButton.setAttribute('data-supported', engine.arSupported.toString());
		arButton.addEventListener('click', () => requestSession('immersive-ar'));
	}
	const vrButton = document.getElementById('vr-button');
	if (vrButton) {
		vrButton.setAttribute('data-supported', engine.vrSupported.toString());
		vrButton.addEventListener('click', () => requestSession('immersive-vr'));
	}
}

if (document.readyState === 'loading') {
	window.addEventListener('load', setupButtonsXR);
} else {
	setupButtonsXR();
}

/* Load main scene */
try {
	await engine.loadMainScene(`${Constants.ProjectName}.bin`);
} catch (e) {
	console.error(e);
	window.alert(`Failed to load ${Constants.ProjectName}.bin:`, e);
}
